<div class="list-container">
  @if (progressSteps && progressSteps.length > 0) {
    <mat-list>
      @for (step of progressSteps; track step) {
        <mat-list-item>
          <atlas-profiler-progress-step
            [progressStep]="step"
          ></atlas-profiler-progress-step>
        </mat-list-item>
      }
    </mat-list>
  }
  @if (importStatusErrors && importStatusErrors.errors.length > 0) {
    <div
      class="errors-list"
      >
      <div class="header" i18n="@@listOfErrorsDetected">
      List of errors detected:
    </div>
      <div style="max-height: 100px; overflow-y: auto">
        @for (errorMessage of importStatusErrors.errors; track errorMessage) {
          <div
            class="error-padding"
            >
            <li class="text">
              {{ errorMessage.error | translate }}
            </li>
          </div>
        }
      </div>
    </div>
  }
</div>
